import SubcategoryPage from '@/components/template/SubcategoryPage';

const TokyoLente = () => {
  const products = [
    {
      title: "Tokyo Lente Model 1",
      imageSrc: "https://images.unsplash.com/photo-1493552152660-f915ab47ae9d?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-lente/model-1"
    },
    {
      title: "Tokyo Lente Model 2",
      imageSrc: "https://images.unsplash.com/photo-1596079890701-dd42edf0b7d4?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-lente/model-2"
    },
    {
      title: "Tokyo Lente Model 3",
      imageSrc: "https://images.unsplash.com/photo-1552454799-ca5cfdc612c8?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-lente/model-3"
    },
    {
      title: "Tokyo Lente Model 4",
      imageSrc: "https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-lente/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Tokyo Lente"
      description="Inovativna ogledala z učinkom leče, ki ustvarjajo edinstveno vizualno doživetje. Združitev japonske tradicije s sodobnim oblikovanjem."
      heroImage="https://images.unsplash.com/photo-1493552152660-f915ab47ae9d?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TokyoLente;